import { Helmet } from 'react-helmet-async';

/**
 * SEO — per-page meta tag component.
 * Usage: <SEO title="..." description="..." path="/tips" />
 * Falls back to the defaults defined in public/index.html if props are omitted.
 */
const BASE_URL = 'https://contractorslab.com';
const DEFAULT_IMAGE = `${BASE_URL}/social-logo-facebook-square.png`;

const SEO = ({
  title,
  description,
  keywords,
  path = '',
  image = DEFAULT_IMAGE,
  type = 'website',
  noindex = false,
}) => {
  const fullTitle = title
    ? `${title} | ContractorsLab`
    : 'ContractorsLab — Where Pros Get Work Done';
  const url = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
